export default {
  AC_GRID_1: 'Sample-Grids',
  AC_GRID_2: 'AutocodeSelectionBox',
  AC_TEMPLATE_SINGLE_LIST: 'ACTemplateSingleList',
  AC_TEMPLATE_DOUBLE_LIST: 'ACTemplateDoubleList',
  AC_TEMPLATE_1_CATEGORY: 'ACTemplate1Category',
  AC_TEMPLATE_1_BRAND_TYPE_KIND_FORM: 'ACTemplate1BrandTypeKindForm',
  AC_TEMPLATE_4: 'ACTemplate4',
  AC_TEMPLATE_2: 'ACTemplate2',
  AC_TEMPLATE_7: 'ACTemplate7',
  AC_TEMPLATE_8: 'ACTemplate8',
  AC_DEFINITIONS: 'ACDefinitions',
};
